import * as React from 'react';

import AccountSwitch from 'src/components/AccountSwitch';

import './AccountSwitchPage.scss';

export default class AccountSwitchPage extends React.Component {
  public render() {
    return (
      <section id="account-switch-page">
        <AccountSwitch />
      </section>
    );
  }
}
